import locale from "../../../utils/locale";

const yesNoData = [
  { display: locale("yes"), value: "Y" },
  { display: locale("no"), value: "N" },
];

const personalBelongingsOptionsData = [
  { display: locale("yes"), value: "Y" },
  { display: locale("need_more_time"), value: "need_more_time" },
  { display: locale("donot_intend_to"), value: "NA" },
];
const keysOptionsData = [
  { display: locale("yes"), value: "Y", helpText: locale("helpTextKey") },
  { display: locale("need_more_time"), value: "need_more_time" },
  { display: locale("do_not_have_keys"), value: "NA" },
];
const followUpOptionsData = [
  { display: locale("hours_2"), value: "2" },
  { display: locale("hours_4"), value: "4" },
  { display: locale("hours_8"), value: "8" },
  { display: locale("other"), value: "other" },
];
const readyForPickUpOptionsData = [
  { display: locale("yes"), value: "Y" },
  { display: locale("pickup_on"), value: "pick_up_on" },
  { display: locale("follow_up_in"), value: "follow_up" },
];

const doesWheelsRollData = [
  { display: locale("tires_inflated"), value: locale("tires_inflated") },
  { display: locale("vehicle_engine_starts"), value: "Vehicle engine starts" },
  {
    display: locale("vehicle_can_drive_safely"),
    value: "Vehicle can drive safely under its own power",
  },
  { display: locale("none"), value: "None" },
];

export default [
  {
    name: "removedPersonalBelongings",
    label: locale("personalBelongings"),
    type: "radio",
    readable: true,
    editable: true,
    required: true,
    dataSource: personalBelongingsOptionsData,
  },
  {
    name: "hasKeys",
    label: locale("hasKeys"),
    type: "radio",
    readable: true,
    editable: true,
    required: true,
    dataSource: keysOptionsData,
  },
  {
    name: "policyHolder",
    getLabel: (sellerCompanyCode) =>
      locale("policyHolder", { sellerCompanyCode }),
    type: "radio",
    readable: true,
    editable: true,
    required: true,
    dataSource: yesNoData,
  },
  {
    name: "keysLocation",
    label: locale("Enter details here..."),
    questionLabel: locale("vehicleKeysLocation"),
    type: "text",
    readable: true,
    editable: true,
    required: true,
    maxLength: 100,
    helpText: locale("vehicleKeysLocationHelpText"),
    positionHelpText: "top",
  },
  {
    name: "vehicleIsBlocked",
    label: locale("isAnythingBlocking"),
    type: "radio",
    readable: true,
    editable: true,
    required: true,
    dataSource: yesNoData,
  },
  {
    name: "doesWheelsRoll",
    label: locale("doesWheelsRoll"),
    type: "checkbox",
    readable: true,
    editable: true,
    required: true,
    dataSource: doesWheelsRollData,
  },
  {
    name: "readyForPickup",
    label: locale("Is your vehicle ready for Copart to pickup?"),
    type: "radio",
    readable: true,
    editable: true,
    required: true,
    dataSource: readyForPickUpOptionsData,
  },
  {
    name: "pickUpOn",
    label: locale("Pick up on"),
    type: "date",
    readable: true,
    editable: true,
    required: true,
  },
  {
    name: "followUp",
    label: locale("Please follow up with me in"),
    type: "radio",
    readable: true,
    editable: true,
    required: true,
    dataSource: followUpOptionsData,
    tab: true,
  },
  {
    name: "comments",
    label: locale("Enter Comments"),
    type: "text",
    readable: true,
    editable: true,
    required: true,
    multiline: true,
    maxLength: 150,
  },
];



// WEBPACK FOOTER //
// ./src/containers/PickupForm/fieldStructure/pickupDetails.uk.js